module.exports = __webpack_public_path__ + "media/images/moovejob-team-img-1-9ed86bedf1fe5ac910edb685f91cb4e3.jpeg";